module.exports = __webpack_public_path__ + "img/artificial-intelligence.e70e8483.svg";